
<template>
	<div class="intro-wrapper">

    <div class="all-years-wrapper">
<div v-for="year in yearsLinks" v-bind:key="year.year" class="single-year-wrapper"
>

<router-link :to="year.link" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + year.img) + ')' }">
<!--<router-link :to="year.link">-->

<div class="bg-text">{{year.year}}</div>
</router-link>


</div>
    </div>

    <div class="table-headline">BREES VS. THE NFL (287 GAMES)
</div>
<StickyStatTable></StickyStatTable>
<RegSeasonReceivers></RegSeasonReceivers>



</div>
</template>

<script>
import RegSeasonReceivers from '@/components/RegSeasonReceivers.vue';
import StickyStatTable from '@/components/StickyStatTable.vue';

export default {
  name: "yearsIntro",
  components: {
    RegSeasonReceivers,
    StickyStatTable
  },
  metaInfo: {
    
    title: 'Drew Brees Stats vs Every NFL Team | Year-to-Year Stats | Pass Catchers List',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data: () => ({ 
  topImage: "brees-2009-top-image.jpg",
  yearsLinks: [
  { year: '2001', img: 'brees-2001-top-image-thumb.gif', link: '/year/2001'},
  { year: '2002', img: 'brees-2002-top-image-thumb.gif', link: '/year/2002'},
  { year: '2003', img: 'brees-2003-top-image-thumb.gif', link: '/year/2003'},
  { year: '2004', img: 'brees-2004-top-image-thumb.gif', link: '/year/2004'},
  { year: '2005', img: 'brees-2005-top-image-thumb.gif', link: '/year/2005'},
  { year: '2006', img: 'brees-2006-top-image-thumb.gif', link: '/year/2006'},
  { year: '2007', img: 'brees-2007-top-image-thumb.gif', link: '/year/2007'},
  { year: '2008', img: 'brees-2008-top-image-thumb.gif', link: '/year/2008'},
  { year: '2009', img: 'brees-2009-top-image-thumb.gif', link: '/year/2009'},
  { year: '2010', img: 'brees-2010-top-image-thumb.gif', link: '/year/2010'},
  { year: '2011', img: 'brees-2011-top-image-thumb.gif', link: '/year/2011'},
  { year: '2012', img: 'brees-2012-top-image-thumb.gif', link: '/year/2012'},
  { year: '2013', img: 'brees-2013-top-image-thumb.gif', link: '/year/2013'},
  { year: '2014', img: 'brees-2014-top-image-thumb.gif', link: '/year/2014'},
  { year: '2015', img: 'brees-2015-top-image-thumb.gif', link: '/year/2015'},
  { year: '2016', img: 'brees-2016-top-image-thumb.gif', link: '/year/2016'},
  { year: '2017', img: 'brees-2017-top-image-thumb.gif', link: '/year/2017'},
  { year: '2018', img: 'brees-2018-top-image-thumb.gif', link: '/year/2018'},
  { year: '2019', img: 'brees-2019-top-image-thumb.gif', link: '/year/2019'},
  { year: '2020', img: 'brees-2020-top-image-thumb.gif', link: '/year/2020'}
  ]


  })
}

</script>

<style>

.bg-text {
    font-size: 60px;
    font-weight: bold;
    font-family: 'Teko', sans-serif;
    color: #000000;
    position: relative;
    z-index: 3;
    line-height: 110px;
    text-decoration: none;
    position: relative;
    top: 9px;
}

.bg-tint-gold {
    background-color: #D3BC8D;
    position: absolute;
    width: 100%;
    height: 100%;
    mix-blend-mode: color;
}

.bg-tint-solid-gold {
    background-color: #d1c481a1;
    position: absolute;
    width: 100%;
    height: 100%;
}

.intro-wrapper {
    padding:90px 0px;
}
.intro-cta-wrapper{
    background: #D3BC8D;
    font-weight: bold;
    font-family: 'Teko', sans-serif;
    font-size: 65px;
    line-height: 87px;
    padding: 10px 20px;
}

.all-years-wrapper {
    display:flex;
    justify-content:space-around;
    align-items:center;
    flex-wrap:wrap;
    padding: 10px;
}

.single-year-wrapper {
    width: 9%;
    position: relative;
    margin: 5px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: #D3BC8D;
    border: 5px solid white;
    transition-duration: .3s;
}

.single-year-wrapper:hover {
    transform: scale(1.1);
    border-color: #efd6a3;
    transition-duration: .3s;
}

.single-year-wrapper > a {
    width: 100%;
    min-height: 117px;
    align-self: center;
    display: flex;
    justify-content: center;
    align-items: center;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    text-decoration: none;
}

.table-headline {
    font-size: 80px;
    font-weight: bold;
    font-family: 'Teko', sans-serif;
    color: white;
    line-height: 60px;
    margin: 20px 0px;
}

@media (max-width:1600px) {
.bg-text {
    font-size: 40px;
    line-height: 53px;
    text-decoration: none;
    position: relative;
    top: 9px;
}

.table-headline {
    font-size: 60px;
    font-weight: bold;
    font-family: 'Teko', sans-serif;
    color: white;
    line-height: 60px;
    margin: 20px 0px;
}


}

@media (max-width:1100px) {
.single-year-wrapper {
    width: 19%;
}
.bg-text {
    font-size: 35px;
    line-height: 35px;
}
.single-year-wrapper:nth-of-type(4n-4) {
    /*border: 2px solid red;*/
    margin-right: 0px;
}

.single-year-wrapper > a {
    width: 100%;
    min-height: 70px;
    }
    .bg-text {

    top: 4px;
}
.table-headline {
    font-size: 50px;
    line-height: 50px;
    margin: 20px 0px;
}


}

@media (max-width:700px) {
    .single-year-wrapper {
    width: 17%;
}
.bg-text {
    font-size: 25px;
    line-height: 25px;
}
.intro-cta-wrapper {
    font-size: 25px;
line-height: 47px;
}
.table-headline {
    font-size: 25px;
    line-height: 25px;
    margin: 10px 0px;
}
}

@media (max-width:420px) {
    .intro-wrapper {
    padding: 50px 0px;
}
.bg-text {
    font-size: 22px;
}


.single-year-wrapper > a {
    min-height: 50px;
}
}
</style>


// WEBPACK FOOTER //
// src/views/Intro.vue